import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface Noticia {
  id: string;
  titulo: string;
  subtitulo: string;
  autor: string;
  imagem_autor_url: string;
  imagem_url: string;
  created_at: string;
  slug: string;
}

export const useNoticiasQuery = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['noticias-publicas'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('noticias')
        .select('id, titulo, subtitulo, autor, imagem_autor_url, imagem_url, created_at, slug')
        .eq('publicado', true)
        .order('created_at', { ascending: false });
      if (error) throw error;
      return (data || []) as Noticia[];
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  return { noticias: data || [], isLoading, error };
};
